module.exports = __webpack_public_path__ + "static/img/tips.6522d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/images/tips.png
// module id = um+J
// module chunks = 1